module.exports = __webpack_public_path__ + "img/qevm-picture.146ed29e.svg";